import * as React from 'react';

import { GenericError, GenericErrorProps } from '../components/GenericError';
import { Layout } from '../components/Layout';

const NotFound: React.FC<GenericErrorProps> = (props) => {
  const renderContent = () => (
    <GenericError
      errorContent="The requested page doesn't exist. Sorry about that."
      headerContent="Oops, wrong address."
      {...props}
    />
  );

  return <Layout renderContent={renderContent} />;
};

export default NotFound;
